export class Utils {
  static formatCompactPrice(
    value: number,
    locale: string,
    currency = "EUR",
  ): string {
    return new Intl.NumberFormat(locale, {
      notation: "compact",
      compactDisplay: "short",
      style: "currency",
      currency,
      maximumFractionDigits: 1,
    }).format(value);
  }

  static formatDate(
    date: Date,
    locale: string,
    options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  ): string {
    return date.toLocaleDateString(locale, options);
  }

  static downloadBlob(blob: Blob, fileName: string) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // free the memory
  }

  static getRandomColor() {
    const colors = [
      "#0891B2",
      "#4F46E5",
      "#DB2777",
      "#C026D3",
      "#65A30D",
      "#059669",
      "#F05252",
      "#E11D74",
      "#0284C7",
    ];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  }
}
